<template>
<div
    v-if="bulk_message != null"
>

    <template
        v-if="bulk_message.filter_profile.before_send_add_list_ids.visible"
    >
        <h2
            style="margin-bottom: 15px"
        >
            Before Sending
        </h2>

        <v-alert
            border="left"
            color="primary"
            colored-border
            type="error"
            elevation="2"
        >
            This feature has been relocated.
            To add recipients from a list, go to the Recipients menu and select “Add Recipients from a List…”
            <br/>
            <br/>
            To proceed with your bulk message, please <a @click="clearBeforeSendAddListIds">clear</a> any selections in the 'Before sending, create…' field below.
        </v-alert>

        <m-edit-text
            :label="bulk_message.filter_profile.before_send_add_list_ids.label"
            :value="bulk_message.filter_profile.before_send_add_list_ids.value_description"
            :read_only="true"
            v-show="bulk_message.filter_profile.before_send_add_list_ids.visible"
            style="margin-left: 15px"
        />
    </template>
    <template
        v-else
    >
        <v-alert
            border="left"
            color="secondary"
            colored-border
            type="info"
            elevation="2"
            class="mt-4"
        >
            Looking for <span class="font-weight-medium">Before Sending</span>? This feature has been relocated.
            To add recipients from a list, go to the Recipients menu and select “Add Recipients from a List…”
        </v-alert>
    </template>

    <h2
        style="margin-bottom: 15px"
    >
        Filters
    </h2>

    <p><b>Filter by other messages</b></p>
    

    <m-edit-text
        :label="bulk_message.filter_profile.filter_days_since_last_bulk_message.label"
        :value="bulk_message.filter_profile.filter_days_since_last_bulk_message.value_description"
        :custom_on_edit="onEditFilterDaysSince"
        :read_only="has_sent"
        v-show="bulk_message.filter_profile.filter_days_since_last_bulk_message.visible"
        style="margin-left: 15px"
    />

    <m-edit-text
        :label="bulk_message.filter_profile.filter_recipients_in_other_bulk_messages.label"
        :value="bulk_message.filter_profile.filter_recipients_in_other_bulk_messages.value_description"
        :custom_on_edit="onEditFilterOtherBulkMessages"
        :read_only="has_sent"
        v-show="bulk_message.filter_profile.filter_recipients_in_other_bulk_messages.visible"
        style="margin-left: 15px"
    />

    <p><b>Filter by time and location</b></p>

     <p 
        v-show="bulk_message.filter_profile.filter_send_time.visible"
        style="margin-left: 15px"
    >
        <a v-on:click="onClickViewTimeRestrictions()" style="text-decoration: underline">Click here for more state by state details</a>
    </p>

    <m-edit-text
        :label="bulk_message.filter_profile.filter_send_time.label"
        :value="bulk_message.filter_profile.filter_send_time.value_description"
        :custom_on_edit="onEditFilterSendTime"
        :read_only="has_sent"
        v-show="bulk_message.filter_profile.filter_send_time.visible"
        style="margin-left: 15px"
    />

    <m-edit-text
        :label="bulk_message.filter_profile.filter_simple_do_not_send_after_wall_time.label"
        :value="bulk_message.filter_profile.filter_simple_do_not_send_after_wall_time.value_description"
        :custom_on_edit="onEditFilterSimpleDoNotSendAfter"
        :read_only="has_sent"
        v-show="bulk_message.filter_profile.filter_simple_do_not_send_after_wall_time.visible"
        style="margin-left: 15px"
    />

    <m-edit-wall-time-dialog
        :title="bulk_message.filter_profile.filter_simple_do_not_send_after_wall_time.label"
        :value="bulk_message.filter_simple_do_not_send_after_wall_time"
        ref="edit-simple-send-after-dialog"
        :optional="true"
        unset_label="Do not use this filter"
        v-on:ok="onSetSimpleDoNotSendAfterFilter"
    />
    
    <p><b>Filter by consent and/or purchase history*</b></p>

    <m-edit-text
        :label="bulk_message.filter_profile.filter_order_history.label"
        :value="bulk_message.filter_profile.filter_order_history.value_description"
        :custom_on_edit="onEditFilterOrderHistory"
        :read_only="has_sent"
        v-show="bulk_message.filter_profile.filter_order_history.visible"
        style="margin-left: 15px"
    />

    <m-edit-text
        :label="bulk_message.filter_profile.filter_consent.label"
        :value="bulk_message.filter_profile.filter_consent.value_description"
        :custom_on_edit="onEditFilterConsent"
        :read_only="has_sent"
        v-show="bulk_message.filter_profile.filter_consent.visible"
        style="margin-left: 15px"
    />

    <v-checkbox
        :label="bulk_message.filter_profile.filter_twilio_carrier_deactivation_report.label"
        v-model="bulk_message.filter_profile.filter_twilio_carrier_deactivation_report.value"
        @change="onSetTwilioCarrierDeactivationReportsFilter"
        :readonly="has_sent || !bulk_message.filter_profile.filter_twilio_carrier_deactivation_report_can_edit"
        :disabled="has_sent || !bulk_message.filter_profile.filter_twilio_carrier_deactivation_report_can_edit"
        v-show="bulk_message.filter_profile.filter_twilio_carrier_deactivation_report.visible"
        style="margin-left: 15px; margin-top: 0px"
        class="mb-3"
        hide-details
    >
        <v-icon 
            slot="append" 
            style="pointer-events: auto;"
            v-on:click="onClickMoreInformationTwilioCarrierDeactivationReports()"
        >
            mdi-information-outline
        </v-icon>
    </v-checkbox>

    <div
        style="margin-left: 45px; max-width: 540px"
        v-if="bulk_message.filter_profile.filter_twilio_carrier_deactivation_report.value"
    >
        <v-text-field
            label="(Optional) Override the number of days to look back for the Number Reassignment Check Since Date"
            :placeholder="bulk_message.filter_profile.default_number_reassignment_check_since_date_look_back_days?.toString()"
            persistent-placeholder
            clearable
            v-model="bulk_message.override_number_reassignment_check_since_date_look_back_days"
            @change="onSetOverrideNumberReassignmentCheckSinceDateLookBackDays"
        ></v-text-field>
    </div>


    <p
        class="mt-6"
        style="margin-left: 15px; font-size: 12px;"
    >
        * &mdash; RedChirp automatically tries to avoid sending bulk messages to recipients who have opted out, and to recipients who appear in tcpalitigatorlist.com (which advertises itself as a database of known TCPA litigators, TCPA trolls, and DNC Complainers) 
    </p>


    <p><b>State-specific filters</b></p>

    <p
        style="margin-left: 15px"
    >
        <a href="https://redchirp.com/questions-about-the-new-texas-law-s-b-140/" target="_blank" style="text-decoration: underline">Click here for more information about Texas S.B. 140</a>
    </p>

    <v-checkbox
        :label="bulk_message.filter_profile.filter_texas_do_not_call_list.label"
        v-model="bulk_message.filter_profile.filter_texas_do_not_call_list.value"
        @change="onSetTexasDoNotCallListFilter"
        :readonly="has_sent"
        :disabled="has_sent"
        v-show="bulk_message.filter_profile.filter_texas_do_not_call_list.visible"
        style="margin-left: 15px"
        hide-details
    />

    <!-- If more states are added to the potential exclusions, then this should be a multi select and the label should come from the backend -->
    <v-checkbox
        label="Try to avoid sending to recipients that either (1) have a phone number with a Texas area code or (2) have an address in Texas. Removal is best effort and may be imperfect."
        :input-value="bulk_message.filter_profile.filter_recipients_in_locations.value.length != 0"
        @change="onSetExcludedLocationsFilter"
        :readonly="has_sent"
        :disabled="has_sent"
        v-show="bulk_message.filter_profile.filter_recipients_in_locations.visible"
        style="margin-left: 15px"
        hide-details
    />


    <p class="mt-4">
        <a v-on:click="onClickTechnicalDetails">
            Filters: Technical Details
        </a>
    </p>

    

</div>
</template>

<script>
export default {
    props: {
        bulk_message: {
            type: Object,
            default: function() { return null; }
        },
    },

    methods: {
        onEditFilterOrderHistory()
        {
            this.$rc.prompt({
                    'title' : 'Order history filter settings',
                    'label' : 'Only send to recipients who have consent on file in RedChirp OR have purchased within the last (number of months)',
                    'value' : this.bulk_message.filter_order_history,
                    'unset_label': 'Do not use this filter',
                    'is_valid': this.$rc.validationRuleInteger(1,null),
                    'after_prompt' : (value) => {
                        
                        this.$emit(
                            'patch',
                            {
                                'filter_order_history': value,
                            },
                        );

                    }
                });
        },

        onEditFilterDaysSince() {
            
            this.$rc.prompt({
                    'title' : 'Recent bulk message filter settings',
                    'label' : this.bulk_message.filter_profile.filter_days_since_last_bulk_message.label,
                    'value' : this.bulk_message.filter_days_since_last_bulk_message,
                    'unset_label': 'Do not use this filter',
                    'is_valid': this.$rc.validationRuleInteger(1,null),
                    'after_prompt' : (value) => {
                        
                        this.$emit(
                            'patch',
                            {
                                'filter_days_since_last_bulk_message': value,
                            },
                        );

                    }
                });
        },

        onEditFilterOtherBulkMessages()
        {
            this.$rc.pick({
                'title': 'Do not send to recipients of other bulk message(s) filter settings',
                'content_before': '',
                'content_after': null,
            
                'choices': [],
            
                'multiple': true,
                'type': 'select_object_type',
                'select_object_type': 'bulk_message',
                'select_label': this.bulk_message.filter_profile.filter_recipients_in_other_bulk_messages.label,
                'initial_value': this.bulk_message.filter_recipients_in_other_bulk_messages,
                'unset_label': 'Do not use this fitler',
            
                'on_ok': (value) => {

                    if ( value == null ) 
                        value = [];
                    
                    
                    this.$emit(
                            'patch',
                            {
                                'filter_recipients_in_other_bulk_messages': value,
                            },
                        );
                },
            
                'on_cancel': () => {}
            
            });
        },

        onEditFilterSimpleDoNotSendAfter()
        {
            this.$refs['edit-simple-send-after-dialog'].showDialog();
        },

        onSetSimpleDoNotSendAfterFilter(value)
        {
            this.$emit(
                'patch',
                {
                    'filter_simple_do_not_send_after_wall_time': value,
                },
            );
        },

        onEditFilterConsent()
        {
            

            this.$rc.pick({
                'title': 'Consent filter settings',
                'content_before': '',
                'content_after': null,
            
                'choices': this.$rc.enumValues('consent_filter_type', false),
            
                'multiple': false,
                'type': 'select',
                'select_label': 'Choose One',
                'initial_value': this.bulk_message.filter_profile.filter_consent.value ?? 'none',
                'unset_label': 'Do not use this filter',
            
                'on_ok': (value) => {
                    if ( value == null ) value = 'none';

                    this.$emit(
                            'patch',
                            {
                                'filter_consent': value,
                            },
                        );
                },
            
                'on_cancel': () => {}
            
            });
        },

        onEditFilterSendTime()
        {
            this.$rc.pick({
                'title': this.bulk_message.filter_profile.filter_send_time.label+' filter settings',
                'content_before': '',
                'content_after': null,
            
                'choices': this.$rc.enumValues('send_time_filter_type', false),
            
                'multiple': false,
                'type': 'select',
                'select_label': this.bulk_message.filter_profile.filter_send_time.label,
                'initial_value': this.bulk_message.filter_send_time ?? 'none',
                'unset_label': 'Do not use this filter',
            
                'on_ok': (value) => {
                    if ( value == null ) value = 'none';

                    this.$emit(
                            'patch',
                            {
                                'filter_send_time': value,
                            },
                        );
                },
            
                'on_cancel': () => {}
            
            });
        },

        onSetTexasDoNotCallListFilter(value)
        {
            this.$emit(
                'patch',
                {
                    'filter_texas_do_not_call_list': value,
                },
            );
        },

        onSetExcludedLocationsFilter(value)
        {
            const list_value = value ? ['US-TX'] : [];

            this.$emit(
                'patch',
                {
                    'filter_recipients_in_locations': list_value,
                },
            );
        },

        onSetTwilioCarrierDeactivationReportsFilter(value)
        {
            this.$emit(
                'patch',
                {
                    'filter_twilio_carrier_deactivation_report': value,
                },
            );
        },

        onSetOverrideNumberReassignmentCheckSinceDateLookBackDays(value)
        {
            this.$emit(
                'patch',
                {
                    'override_number_reassignment_check_since_date_look_back_days': value,
                },
            );
        },        

        onClickViewTimeRestrictions()
        {
            window.open(this.$router.resolve({
                'name': 'public-restricted-messaging-times',
                'params' : {
                }
            }).href, '_blank');
        },

        onClickTechnicalDetails()
        {
            this.$rc.technicalDetails({
                'title': 'Filter Technical Details',
                'technical_details': this.bulk_message.filter_profile.technical_details,
            });
        },

        onClickMoreInformationTwilioCarrierDeactivationReports()
        {
            window.open('https://redchirp.com/removing-recipients-using-twilio-carrier-deactivation-reports/', '_blank');
        },

        clearBeforeSendAddListIds()
        {
            this.$rc.confirm({
                title: 'Clear Lists',
                body: 'Are you ready to clear all "before sending" lists from this bulk message?',
                btn_text_ok: 'Yes, Clear Lists',
                btn_text_cancel: 'Not Yet',
                on_ok: () => {
                    this.$emit(
                        'patch',
                        {
                            'before_send_add_list_ids': [],
                        },
                    );
                }
            });
        },

    },

    computed: {
        has_sent() {
            if ( this.bulk_message == null ) return false;
            return this.bulk_message.sent_time != null;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>